import { defineStore } from 'pinia'
import { useClockStore } from './clock.js'

export const useMysterySoundGuessStore = defineStore('mystery_sound', {
  state: () => ({
    id: null,
    guess: null,
    name: null,
    place: null,
    prompt: null,
    vote_end: null,
    correct: undefined,
  }),

  actions: {
    initilize() {
      const params = new URLSearchParams(window.location.search)
      this.id = params.get('id')
      this.guess = params.get('guess')
      this.name = params.get('name')
      this.place = params.get('place')
      this.prompt = params.get('prompt')
      this.vote_end = params.get('vote_end')
      this.correct = params.get('correct') ? params.get('correct') === 'true' : undefined
    },
  },

  getters: {
    timeRemaining: (state) => {
      const clock = useClockStore()
      return Math.floor(state.vote_end - clock.now.getTime() / 1000)
    },
    isExpired: (state) => {
      const clock = useClockStore()
      return state.vote_end - clock.now.getTime() / 1000 < 0
    },
  },
})
